module.exports = __webpack_public_path__ + "img/PLP-logo.84535563.svg";